import PricingMethodWrapper from "./PricingMethodWrapper";

export default PricingMethodWrapper;



// WEBPACK FOOTER //
// ./src/components/Pricebook/PricingMethodWrapper/index.js